var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mt-15"},[_c('v-container',[_c('center',[_c('h1',[_vm._v("Die angefragte Seite ist leider nicht Verfügbar!")]),_c('p',[_vm._v("Zurück zur "),_c('router-link',{attrs:{"to":"/"}},[_vm._v("Startseite")])],1)])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }